
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staycation/staycation-details",
      function () {
        return require("private-next-pages/staycation/staycation-details.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staycation/staycation-details"])
      });
    }
  